import React, { useState } from 'react';
import './Generate.scss'

import Slider from 'react-input-slider';

function Generate() {

    const proxies = [
        '89.244.3698.3575:efkjfhsjs:fb93u4uhrif20I 89.244.3698.3575:efkjfhsjs:fb93u4uhrif20I 89.244.3698.3575:efkjfhsjs:fb93u4uhrif20I  89.244.3698.3575:efkjfhsjs:fb93u4uhrif20I  89.244.3698.3575:efkjfhsjs:fb93u4uhrif20I  89.244.3698.3575:efkjfhsjs:fb93u4uhrif20I  89.244.3698.3575:efkjfhsjs:fb93u4uhrif20I  89.244.3698.3575:efkjfhsjs:fb93u4uhrif20I  89.244.3698.3575:efkjfhsjs:fb93u4uhrif20I  89.244.3698.3575:efkjfhsjs:fb93u4uhrif20I  89.244.3698.3575:efkjfhsjs:fb93u4uhrif20I  89.244.3698.3575:efkjfhsjs:fb93u4uhrif20I  89.244.3698.3575:efkjfhsjs:fb93u4uhrif20I'
    ]

    const [state, setState] = useState({ x: 0});
    
  return (
    <div className='dashContainer'>
        <div className='containerHeader'>
            <h1>Generate Proxies</h1>
        </div>

        <div className='generateGrid'>
            <div>
                <div className='inputGrid'>
                    <div>
                        <label className='label'>Proxy Type</label> <br />
                        <div className='select-wrapper'>
                            <select>
                                <option value="" selected disabled>Select Type</option>
                                <option value="1">Pool 1</option>
                                <option value="2">Pool 2</option>
                                <option value="3">Pool 3</option>
                            </select>
                        </div>
                    </div>
                    <div>
                        <label className='label'>Proxy Type</label> <br />
                        <div className='select-wrapper'>
                            <select>
                                <option value="" selected disabled>Select Country</option>
                                <option value="1">United States</option>
                                <option value="2">Europe</option>
                                <option value="3">Asia</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className='amountBar'>
                    <Slider
                        axis="x"
                        xstep={25}
                        xmin={0}
                        xmax={1000}
                        x={state.x}
                        onChange={({ x }) => setState({ x: parseFloat(x.toFixed(2)) })}

                        styles={{
                            track: {
                              backgroundColor: '#262222',
                              width: '100%',
                            },
                            active: {
                              backgroundColor: '#FF8329'
                            },
                            thumb: {
                              width: 20,
                              height: 20,
                              color: '#E0E5E8',
                            }
                          }}
                    />
                </div>

                <div className='inputGrid2' style={{marginTop: 15}}>
                    <input type="text" placeholder='Quantity' value={state.x} disabled/>
                    <button className='btn generateButton text-nowrap'>Generate Proxies</button>
                </div>
            </div>

            <div className='selectArea'>
                <div className='proxyNumbers'>
                    <h3 className='proxyNumber'>15 Proxies</h3>
                    <h3 className='copyList'>Copy List</h3>
                </div>

                <textarea value={proxies} onChange='' disabled/>
            </div>
        </div>
    </div>
  )
}

export default Generate